import styled from "styled-components";

const S = {
    PageWrapper: styled.div`
        background: #f8fafc;
        min-height: 100vh;
        padding-bottom: 80px;
    `,
    HeroSection: styled.section`
        background: linear-gradient(135deg, #00A9C4 0%, #00798c 100%);
        padding: 80px 20px;
        text-align: center;
        color: white;

        .hero-content {
            max-width: 800px;
            margin: 0 auto;

            h1 {
                font-size: 3.5em;
                font-weight: 800;
                margin: 0 0 15px 0;
                letter-spacing: -1px;

                @media (max-width: 768px) {
                    font-size: 2.5em;
                }
            }

            h2.subtitle {
                font-size: 1.5em;
                font-weight: 400;
                margin: 0 0 30px 0;
                opacity: 0.9;
                
                @media (max-width: 768px) {
                    font-size: 1.2em;
                }
            }
        }
    `,
    Breadcrumb: styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 10px;
        font-size: 1.1em;
        opacity: 0.9;
        
        a, span {
            color: white;
            text-decoration: none;
            font-weight: 500;
            transition: opacity 0.2s ease;
            
            &:hover {
                opacity: 0.7;
            }
        }
        
        .separator {
            font-size: 0.9em;
            opacity: 0.6;
        }
    `,
    ContentWrapper: styled.div`
        max-width: 1000px;
        margin: -40px auto 0;
        padding: 0 20px;
        position: relative;
        z-index: 10;
        
        .info-container {
            background: white;
            border-radius: 24px;
            padding: 50px;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
            border: 1px solid rgba(0,0,0,0.04);
            margin-bottom: 40px;

            @media (max-width: 768px) {
                padding: 30px 20px;
            }

            .image-wrapper {
                width: 100%;
                border-radius: 16px;
                overflow: hidden;
                margin-bottom: 40px;
                box-shadow: 0 10px 30px rgba(0,0,0,0.1);
                
                img {
                    width: 100%;
                    height: auto;
                    display: block;
                    object-fit: cover;
                    max-height: 450px;
                }
            }

            .date-info {
                color: #64748b;
                font-size: 0.95em;
                margin-bottom: 30px;
                text-align: right;
                font-style: italic;
            }

            .text-content {
                h3 {
                    color: #00A9C4;
                    font-size: 1.8em;
                    margin: 40px 0 20px;
                    font-weight: 700;
                }

                p {
                    font-size: 1.15em;
                    line-height: 1.8;
                    color: #334155;
                    margin-bottom: 20px;
                    text-align: justify;
                }
            }
        }
    `
};

export default S;